// extracted by mini-css-extract-plugin
export default {"root":"overlappingLoader_root__uWK4d","stripes-animation-background-keyframes":"overlappingLoader_stripes-animation-background-keyframes__krRgi"};